import { RuleResult } from 'types/DeclarationP5'
import { CL147_SECURITY_AGREEMENT_AREA_COUNTRIES } from 'shared/ncts/common/constants'
import { extractCountryFromDepartureOffice } from 'shared/ncts/common/classifier-util'

const C0710Validator = {
  validateLocationOfGoodsRequirement: ({
    additionalDeclarationType,
    departureCustomsOffice,
  }: {
    additionalDeclarationType: string
    departureCustomsOffice: string
  }): RuleResult => {
    if (additionalDeclarationType === 'D') {
      return 'OPTIONAL'
    }

    const departureCountry = extractCountryFromDepartureOffice(departureCustomsOffice)
    if (departureCountry && CL147_SECURITY_AGREEMENT_AREA_COUNTRIES.includes(departureCountry)) {
      return 'OPTIONAL'
    }

    return 'REQUIRED'
  },
} as const

export default C0710Validator
